import { useEffect, useState } from "react";
import { CTAButton } from "@/components/CTAButton";

export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={
        "md:hidden fixed inset-x-0 bottom-0 z-40 px-3 pt-3 " +
        "bg-gradient-to-t from-[#F7F6F3] via-[#F7F6F3]/95 to-transparent " +
        "transition-all duration-500 " +
        (visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0")
      }
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
      {...(!visible ? { inert: "" as unknown as boolean } : {})}
    >
      <p className="mb-2 text-center text-[11px] font-semibold tracking-[0.02em] text-[#4A4A4E]">
        Particular · a partir de R$ 600 · sem convênio
      </p>
      <CTAButton eventName="form_open_sticky_mobile" size="md" />
    </div>
  );
}
